import React, { useEffect } from "react";
import withRouter from "../../Components/Common/withRouter";

// Material UI
import { Grid, Card, CardContent, Typography, Button, Box } from '@mui/material';

// Material UI Icons
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import OutputOutlinedIcon from '@mui/icons-material/OutputOutlined';

// Images
import logoLightFull from "../../assets/images/logo-light-full.png";
import authEffect2 from "../../assets/images/effect-pattern/auth-effect-2.png";
import authEffect from "../../assets/images/effect-pattern/auth-effect.png";

//redux
import { useDispatch } from "react-redux";
import { logoutUser } from "../../slices/thunk";
import { Colortheme } from "../comman";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";

const Logout = () => {

    document.title = "Log Out | Rudrix";

    const theme: any = useTheme();
    const { primary, white75, textmuted, cardbg } = Colortheme();

    const CustomButton = styled(Button)({
        padding: '10px 14px',
        fontSize: '14px'
    });



    const dispatch: any = useDispatch();

    useEffect(() => {
        dispatch(logoutUser());
    }, [dispatch]);



    return (
        <React.Fragment>
            <Box style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: theme.palette.mode === 'light' ? '#eff2f7' : '#2b313e' }}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={7} padding={'48px 16px'}>
                        <Grid container justifyContent="center" borderRadius={'8px'} overflow={'hidden'} sx={{ backgroundColor: cardbg }}>
                            <Grid item xs={12} md={5} >
                                <Box sx={{ padding: '20px', height: '100%', }}>
                                    <Card sx={{
                                        backgroundColor: primary,
                                        height: '100%',
                                        borderRadius: '8px',
                                    }}>
                                        <Box sx={{ padding: { xs: '24px', md: '40px' }, height: '100%', position: 'relative' }}>
                                            <Box sx={{ height: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
                                                <Box>
                                                    <img src={logoLightFull} alt="rudrix" height="26" />
                                                </Box>
                                                <Box sx={{ margin: { xs: '20px 0', md: '60px 0' } }}>
                                                    <Typography sx={{ fontSize: '26px', fontWeight: '600', marginBottom: '8px', color: '#fff' }}>Start your journey with us.</Typography>
                                                    <Typography variant="body2" sx={{ fontSize: 14, color: white75 }}>
                                                        It brings together your tasks, projects, timelines, files and more
                                                    </Typography>
                                                </Box>
                                                <Box textAlign={'center'}>
                                                    <Typography variant="body2" margin={0} sx={{ fontSize: 14, color: white75 }}>
                                                        ©{new Date().getFullYear()} Rudrix. All rights reserved.
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            {/* background image */}
                                            <Box sx={{ position: 'absolute', left: { xs: '-30px', md: '-26px' }, top: { xs: '-40px', md: '-40px' } }}>
                                                <img src={authEffect} alt="rudrix" />
                                            </Box>
                                            {/* circle center */}
                                            <Box>
                                                <Box sx={{ display: { xs: 'block', md: 'none' }, position: 'absolute', top: '-20px', left: '20px' }}>
                                                    <img src={authEffect2} style={{ width: '300px', height: '300px' }} alt="rudrix" />
                                                </Box>
                                                <Box sx={{ display: { xs: 'none', md: 'block' }, position: 'absolute', top: '0', right: '0', transform: 'rotate(320deg)' }}>
                                                    <img src={authEffect2} alt="rudrix" />
                                                </Box>
                                            </Box>
                                            {/* bottom image */}
                                            <Box sx={{ position: 'absolute', right: { xs: '-26px', md: '-14px' }, top: { xs: '90px', md: '72%' }, }}>
                                                <img src={authEffect} alt="rudrix" />
                                            </Box>
                                        </Box>
                                    </Card>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <Card sx={{ margin: 0, border: 0, backgroundColor: cardbg, padding: '0' }} elevation={0}>
                                    <CardContent sx={{ paddingX: 0, padding: { xs: '0px', md: '48px' } }}>
                                        <Box style={{ textAlign: 'center', padding: '24px' }}>
                                            <OutputOutlinedIcon color="primary" sx={{ height: 77, width: 66 }} />
                                            <Box sx={{ paddingTop: '-20px' }}>
                                                <h5 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '8px', color: textmuted }}>Well done !</h5>
                                                <p style={{ color: textmuted, fontSize: '14px', marginBottom: '16px' }}>Thank you for using <span style={{ fontWeight: 700 }}>Rudrix</span></p>
                                                <p style={{ color: textmuted, fontSize: '14px', marginBottom: '16px' }}>Aww yeah, you successfully read this important message.</p>
                                                <CustomButton variant="contained" color="primary" fullWidth type="button" href={`${process.env.PUBLIC_URL}/login`}>
                                                    Sign In
                                                </CustomButton>
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>
    );
};

export default withRouter(Logout);
